import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';

import theme from '../../theme';
import { SidebarItem } from '../../components/Sidebar';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';;
import AddIcon from '@mui/icons-material/Add';
import TextField from '@mui/material/TextField';
import Fab from '@mui/material/Fab';
import { Box } from '@mui/material';
import Sidebar, { SidebarContent, SidebarHeader } from './Sidebar/Sidebar';
import DeviceCard from './DeviceCard';
import DeviceInformation from './DeviceInformation';
import toast from "../../../utils/ToasterService";
import log from 'loglevel'
import {t} from 'i18next'
import {Trans} from 'react-i18next'
import Snackbar from '@mui/material/Snackbar';

const styles = {
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    display: 'flex',
    height: '100%',
  },
  cardWrapper: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowX:'hidden',
    overflowY:"auto",
    height:'100%',
    marginBottom:20,
    paddingBottom:20,
    //flexWrap: 'wrap',
    //maxWidth: '80%',
    [theme.breakpoints.down('xs')]: {
        alignItems: 'center',
        flexDirection: 'column',
        height:'100%',
        overflowX:'hidden',
        overflowY:"auto",
        //marginBottom:20,
        //paddingBottom:20,

    },
    [theme.breakpoints.down('sm')]: {
        alignItems: 'center',
        flexDirection: 'column',
        height:'100%',
        overflowX:'hidden',
        overflowY:"auto",
        //marginBottom:20,
        //paddingBottom:20,

    }
},
cardsTitle: {
    //position: 'absolute',
    marginTop: 20,
    marginBottom: 10,
    padding: '0 10px 10px 0',
    [theme.breakpoints.down('xs')]: {
        marginLeft: '7px',
    },
},
cards: {
    //position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    paddingTop: theme.spacing.unit * 8,
    marginBottom:20,
    paddingBottom:20,

    [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom:20,
        paddingBottom:20,
    },
},
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardTitle: {
      //marginTop: 20,
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
  },
  cardItems: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap:theme.dimensions.cardGap,
    marginBottom:5,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  // view specific
  SidebarItemCol: {
    display: 'flex',
    flexDirection: 'column',
  },
  user: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  userDelete: {
    fontWeight: 600,
    lineHeight: 2,
    color: theme.palette.error.dark,
  },
  deviceSpecsRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  deviceSpecsRowItem: {
    marginRight: 30,
  },
  fabButton: {
    position: 'absolute',
    //bottom: theme.spacing.unit * 3,
    //right: theme.spacing.unit * 6,
    bottom: 30,
    right: 60,
      backgroundColor: theme.palette.primary.dark,
      '&:hover': {
        backgroundColor: theme.palette.primary.main
      },
      // color: theme.palette.primary.dark
  },
  textFieldFormLabel: {
    '&$textFieldFocused': {
        color: theme.palette.primary.dark,
    },
},
textFieldFocused: {},
textFieldUnerline: {
    '&:after': {
        borderBottomColor: theme.palette.primary.dark,
    },
},
};

class DevicesView extends PureComponent {
    static propTypes = {
      devices: PropTypes.shape({}),
      activeDeviceId: PropTypes.string,
      onActivateDevice: PropTypes.func.isRequired,
      onCreateDevice: PropTypes.func.isRequired,
      onUpdateDevice: PropTypes.func.isRequired,
    }

    static defaultProps = {
      activeDeviceId: {},
      devices: {},
    }

    state = {
      sidebarOpen: false,
      selectedDevice: undefined,
      deviceCreatable: false,
      device: {
          deviceid: "",
          label: ""
      },
      view: 'device',
      deviceVarList: '',
      gateWayData: '',
    }

    componentWillMount(){
      // this.secondLoad()

    }

    componentDidMount(){
      log.debug(this.state)
    }


    selectDevice = (selectedDeviceId) => {
      this.setState({
        sidebarOpen: true,
        view: 'device',
        selectedDevice: this.props.devices[selectedDeviceId],
      });
      this.props.onMyload()
      // this.setState({
      //   toggle : !this.state.toggle
      // })
    }

    handleSidebarClose = () => {
      this.setState({ sidebarOpen: false, selectedDevice: null });
      this.props.onMyload()
      // this.selectDevice()
    }

    handleRequestCreateDevice = () => {
      this.setState({ view: 'requestcreatedevice', sidebarOpen: true });
    }

    dispatchView () {
      switch (this.state.view) {
        case 'requestcreatedevice':
          return this.renderRequestCreateDevice();
        case 'device':
        default:
          return this.renderDeviceInformation();
      }
    }

    handleChangeValue = name => event => {
      this.setState({
        deviceCreatable: event.target.value.length > 3,
        device: Object.assign({}, this.state.device, { [name]: event.target.value })
      });
    };

    handleCreateDevice = () => {

      // Add Toast when Device creation is done on wrong
        let _this = this;
        const id = this.state.device.deviceid.replace("esp32_","");
        this.handleSave()
            .then(function(res) {
                _this.setState({ sidebarOpen: false, selectedDevice: null });
                toast.success(t('Devices.toast_device_creation_success_01') + id + t('Devices.toast_device_creation_success_02'));
            })
            .catch(function(error) {
                if (typeof error.data !== "undefined") {
                    toast.error(t('Devices.toast_device_creation_error'));
                    log.error("Adding device failed: ", error.data.message)
                }
            })
    }

    isDeviceCreateable() {
        log.debug(this.state.device);
        if(this.state.device.deviceid.length < 3 || this.state.device.label.length === 0) {
            return true;
        }
        return false;
    }

    handleSave = () => {
      return this.props.onCreateDevice({
        deviceId: this.state.device.deviceid,
        label: this.state.device.label,
      });
    }

    renderRequestCreateDevice () {
      const { classes } = this.props;
      return (
        <div>
           {<SidebarHeader
            title={t('Devices.sidebar_header_create')}
            onClose={this.handleSidebarClose}
            //onAction={() => {}}
            />}
         {<SidebarContent>
            <SidebarItem>
              <Typography variant='caption'>
                <Trans i18nKey="Devices.sidebar_item_header_create"></Trans>
              </Typography>
              <div style={styles.SidebarItemCol}>
                <TextField
                 InputProps={{
                            classes: {
                                underline: styles.textFieldUnerline,
                                borderColor:"red"
                            },
                        }}
                        InputLabelProps={{
                            FormLabelClasses: {
                                root: styles.textFieldFormLabel,
                                focused: styles.textFieldFocused,
                            },
                        }}
                  style={{ width: '100%' }}
                  /* sx={{
                    color:"red",
                    input: {
                           color: "#ffffff",
                           borderBottom: "1px solid #ffffff",
                           },
                     }} */


                  label={t('Devices.sidebar_input_label_deviceid_create')}
                  margin="normal"
                  variant={'standard'}
                  value={this.state.device.deviceid}
                  onChange={this.handleChangeValue('deviceid')} />
                  <TextField
                   InputProps={{
                            classes: {
                                underline: styles.textFieldUnerline
                            },
                        }}
                        InputLabelProps={{
                            FormLabelClasses: {
                                root: styles.textFieldFormLabel,
                                focused: styles.textFieldFocused,
                            },
                        }}
                      style={{ width: '100%' }}

                      label={t('Devices.sidebar_input_label_devicename_create')}
                      margin="normal"
                      variant={'standard'}
                      value={this.state.device.label}
                      onChange={this.handleChangeValue('label')} />
                      <br/>
                <Button
                  color="primary"
                  variant='outlined'
                  onClick={this.handleCreateDevice}
                  disabled={this.isDeviceCreateable()}
                  style={{color: theme.palette.primary.dark, borderColor: theme.palette.primary.dark, padding: 0, width: 175 }}
                  >
                  <Trans i18nKey="Devices.button_connect"></Trans>
                  </Button>
              </div>
            </SidebarItem>
          </SidebarContent>}
        </div>
      );
    }

    simulateSidebarOpen(){

    }

    parseGatewayData(gw_data_raw, deviceid) {
      if (gw_data_raw) {
        let rawdata_gw_articlecode = gw_data_raw.app_name
        let rawdata_gw_revision = (gw_data_raw.board_rev == null)?"20A":gw_data_raw.board_rev
        let separatorPos = rawdata_gw_articlecode.indexOf("-", 0)
        let gateWayData = {
          articlecode: rawdata_gw_articlecode.replace("CEW0037S", "CEW0037E").slice(0, separatorPos).concat(rawdata_gw_revision),
          fw_version: gw_data_raw.fw_version,
          id: deviceid.replace("esp32_", ""),
          time_sync_enable: gw_data_raw.time_sync_enable,
        }
        return gateWayData
      } else {
        let gateWayData = {}
        return gateWayData
      }
    }

    renderDeviceInformation () {
      log.debug("SELECTED DEVICE:", this.state.selectedDevice)
      return (
        <div >

        <DeviceInformation
          device={this.state.selectedDevice}
          onSave={this.props.onUpdateDevice}
          onClose={this.handleSidebarClose}
          onDeleteDevice={this.props.onDeleteDevice}
          onDeleteAssignment={this.props.onDeleteAssignment}
          onActivate={this.props.onActivateDevice}
          currentUser={this.props.currentUser}
          isActive={this.state.selectedDevice && this.state.selectedDevice.id === this.props.activeDeviceId}
          deviceVarList={this.props.deviceVarList}
          // gateWayData = {this.props.gateWayData}

          gateWayData = {this.parseGatewayData(this.props.gateWayData, this.props.currentDeviceID)}

          onMyload = {this.props.onMyload}
          // onMyload2= {this.props.onMyload2}
          selectDevice={this.selectDevice}
          simulateSidebarOpen={this.simulateSidebarOpen}
           />
            </div>
      );
    }

    render() {
      const { classes } = this.props;

      const activeDevices = [];
      const inactiveDevices = [];

      Object.values(this.props.devices).forEach((device) => {
        const card = (<DeviceCard
          key={"deviceCard" + device.id}
          isSelected={this.state.selectedDevice && this.state.selectedDevice.id === device.id}
          sidebarOpen={this.state.sidebarOpen}
          active={this.props.activeDeviceId === device.id}
          device={device}
          onSelect={this.selectDevice}
        />);
        this.props.activeDeviceId === device.id ? activeDevices.push(card) : inactiveDevices.push(card);
      });

      return (
        <div style={styles.root}>
          <div style={styles.cardWrapper}>
            <span style={styles.cardsTitle}>
              <Typography variant="h5">{this.props.title}</Typography>
            </span>
            <Box style={styles.cards} rowGap={theme.dimensions.cardGap/7} columnGap={theme.dimensions.cardGap/7}>
              <div style={styles.cardContainer}>
                <Typography variant="h5" style={{...styles.cardTitle, marginBottom:15}}>
                  <Trans i18nKey="Devices.card_title_active"></Trans>
                </Typography>
                <div>
                  {(activeDevices.length !== 0) ?
                    (activeDevices) :
                    (<Typography variant="body1" style={styles.cardTitle}>
                      <Trans i18nKey="Devices.card_replacement_no_active_devices"></Trans>
                    </Typography>)
                  }
                </div>
              </div>
              <div style={{...styles.cardContainer, marginTop:5}}>
                <Typography variant="h5" style={{...styles.cardTitle, marginBottom:15}}>
                  <Trans i18nKey="Devices.card_title_other"></Trans>
                </Typography>
                <div style={styles.cardItems}>
                  {(inactiveDevices.length !== 0) ?
                    (inactiveDevices) :
                    (<Typography variant="body1" style={styles.cardTitle}>
                      <Trans i18nKey="Devices.card_replacement_no_inactive_devices"></Trans>
                    </Typography>)
                  }
                </div>
              </div>
            </Box>
          </div>


          <Fab style={styles.fabButton} aria-label={'Add new Device'} color={'primary'} onClick={this.handleRequestCreateDevice}>
            <AddIcon />
          </Fab>
          <Sidebar open={this.state.sidebarOpen} >
            {this.dispatchView()}
          </Sidebar>
        </div>
      );
    }
}

export default DevicesView;
